import React, { Component } from 'react';
import Header from '../../components/main.header.component';

class Truisms extends Component {
  render() {
    return (
      <div className="truisms">
        <Header
          props={this.props}
          />
          <div className="shade-headline">
            Truisms
          </div>
          <div className="shade-text">
            <h4>Google Chrome Extension blending Art with Technology.</h4>
            I had wanted to build a Chrome Extension for some time now.
            <br />
            While enjoying my morning coffee, I watched an Art21 featuring Jenny Holzer,
            one of my favorite artists, and the idea hit.<br/>
            Moments later, <i>Truisms</i> was born.
          </div>
          <div id="truism-link">
              <a href="https://chrome.google.com/webstore/detail/truisms/lmhphhnaopkffigallbhlmgmiimddpnc?hl=en" target='_blank' rel="noopener noreferrer">
                Get The Extension Here
              </a>
          </div>
          <div className="truism-blue">
            <img src="/images/design/truisms.gif" alt="truism" />
          </div>
          <div className="shade-goals">
            <div className="shade-text">
              <h2>Features</h2>
              <ul>
                <li> Built with vanilla Javascript, HTML5 and CSS3. </li>
                <li> Optimized to only use 3 functions for extremely fast New Tab load time. </li>
                <li> Randomly generates a pastel colored background for contrast against a large, bold red Truism. </li>
                <li> Over 500 unique Truisms to make opening new tabs a fun experience. </li>
              </ul>
            </div>
          </div>
      </div>
    );
  }
}

export default Truisms;
